<template>
  <div>
    <v-container fluid dense>
      <!-- <v-row justify="space-around"> -->
      <v-row justify="space-between">
        <template v-if="usaImpostazioniDashboard">
          <v-col v-for="(item, index) in dashboard" :key="index">
            <component :is="item.componente" :item="item" :routerLeave="routerLeave"/>
          </v-col>
        </template>
        <template v-else>
          <v-col>
            <riepilogo-fatture
              v-if="mostraRiepilogoFatture"
              id="fatture"
              :avviaTimer="true"
              tipo="year"
              :sceltaPeriodo="true"
              categoria="Riepilogo fatturazione"
              switchLabel="Ultimi 12 giorni"
              :routerLeave="routerLeave"
            >
            </riepilogo-fatture>
          </v-col>            
          <v-col>
            <snipplet-tabella-manuale
              id="settimana"
              tipo="week"
              :avviaTimer="true"
              label="Giorno"
              switchLabel="Ultimi 7 giorni"
              categoria="Venduto della settimana"
              descrizione="Movimenti con causale vendita"
              :lastElement="true"
              :routerLeave="routerLeave"
            >
            </snipplet-tabella-manuale>
          </v-col>      
          <v-col>
            <snipplet-tabella-manuale
              id="mese"
              tipo="month"
              :avviaTimer="true"
              label="Giorno"
              switchLabel="Ultimi 30 giorni"
              categoria="Venduto del mese"
              descrizione="Movimenti con causale vendita"
              :routerLeave="routerLeave"
            >
            </snipplet-tabella-manuale>
          </v-col>      
          <v-col>
            <snipplet-tabella-manuale
              id="anno"
              tipo="year"
              label="Mese"
              switchLabel="Ultimi 12 mesi"
              categoria="Venduto dell'anno"
              descrizione="Movimenti con causale vendita"
              :routerLeave="routerLeave"
            >
            </snipplet-tabella-manuale>
          </v-col>
          <v-col>
            <snipplet-tabella-manuale
              id="marchio"
              tipo="year"
              label="Marchio"
              switchLabel="Ultimi 12 mesi"
              categoria="Venduto per marchio"
              descrizione="Movimenti con causale vendita"
              :sceltaRaggruppamento="true"
              :sceltaPeriodo="true"
              :tipiRaggruppamento="tipiRaggruppamento1"
              :tipiRaggruppamentoVariabili="tipiRaggruppamentoVariabili1"
              :routerLeave="routerLeave"
            >
            </snipplet-tabella-manuale>
          </v-col>
          <v-col>
<!--              DA COMPLETARE 
            <grafico
              id="marchio"
              tipo="year"
              label="Marchio"
              switchLabel="Ultimi 12 mesi"
              categoria="Venduto per marchio"
              descrizione="Movimenti con causale vendita"
              :sceltaRaggruppamento="true"
              :sceltaPeriodo="true"
              :tipiRaggruppamento="tipiRaggruppamento1"
              :tipiRaggruppamentoVariabili="tipiRaggruppamentoVariabili1"
              :routerLeave="routerLeave">             
            </grafico> -->
            <snipplet-tabella-manuale
              id="fasciaOraria"
              tipo="year"
              label="Fascia Oraria"
              switchLabel="Ultimi 12 mesi"
              categoria="Venduto per fascia oraria"
              descrizione="Movimenti con causale vendita"
              :sceltaRaggruppamento="true"
              :sceltaPeriodo="true"
              :soloScontrini="true"
              :tipiRaggruppamento="tipiRaggruppamento2"
              :tipiRaggruppamentoVariabili="tipiRaggruppamentoVariabili2"
              :routerLeave="routerLeave"
            >
            </snipplet-tabella-manuale>
          </v-col>            
        </template>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import { verificaLicenza } from '@/mixins/verificaLicenza.js'
  import { insomnia } from '@/components/insomnia'
  import SnippletTabellaManuale from './elementi/snippletTabellaManuale.vue'
  import SnippletTabella from './elementi/snippletTabella.vue'
  import SnippletTabellaDate from './elementi/snippletTabellaDate.vue'
  import Tabella from './elementi/tabellaSpark.vue'
  import RiepilogoFatture from './elementi/riepilogoFatture.vue'
  /* import Grafico from './elementi/grafico.vue' */
  import configurazioni from '@/services/configurazioniService.js'

  export default {
    name: 'Dashboard',
    components: {
      SnippletTabella,
      SnippletTabellaManuale,
      SnippletTabellaDate,
      Tabella,
      RiepilogoFatture
     /*  Grafico */
      /*       SnippletSparkline */
    },
    mixins: [verificaLicenza, insomnia],
    data: () => ({
      tipiRaggruppamento1: ['Marchio', 'Categoria1', 'Taglia', 'Colore'], // TODO: prendere da db
      tipiRaggruppamentoVariabili1: ['marchio', 'statistici.categoria1.descrizione', 'varianti.variante1.descrizione', 'varianti.variante2.descrizione'],  
      tipiRaggruppamento2: ['Fascia oraria', 'Operatore'], // TODO: prendere da db
      tipiRaggruppamentoVariabili2: ['fasciaOraria', 'operatore'],       
      routerLeave: 0,
      dashboard: null,
      usaImpostazioniDashboard: false,
      mostraRiepilogoFatture: false
    }),
    created() {
      setTimeout(async () => {
        await this.gestioneToken()
        await this.cicleSyncProcess()
      }, 500)
    },
    async mounted() {
      await this.verificaModuliLocali()
      const dashboard = await configurazioni.getConfigurazione('backoffice', 'dashboard')
      if (dashboard && dashboard.length > 0) {
        this.dashboard = dashboard
        this.usaImpostazioniDashboard = true
      }

      const moduliLicenza = this.$store.getters.moduliLicenza
      // console.log('mounted', moduliLicenza)
      if (moduliLicenza.includes('fatturazioneElettronica')) {
        this.mostraRiepilogoFatture = true
      } 
    },
    async beforeRouteLeave (to, from , next) {
      console.log('route leave idx', from)
      this.routerLeave++
      await this.$nextTick()
      next()
    },
    beforeRouteEnter (to, from, next) {
      next(vm => {
        // access to component public instance via `vm`
      })
    },    
    methods: {
    }
  }
</script>
